import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styles from '../../styles/cr.module.scss';
import { IWithErrorHandlingProps, withErrorHandling } from '../withErrorHandling';
import { SignOffType } from '../../refData/SignOffType';
import { useParams } from 'react-router-dom';
import { ICommandBarItemProps } from '@fluentui/react/lib/CommandBar';
import { CrCommandBar } from '../cr/CrCommandBar';
import { SignOffList } from '../signOff/SignOffList';
import { Period } from '../../refData/Period';
import { SignOffPageSettings } from '../project/SignOffPageSettings';
import { DataContext } from '../DataContext';
import { IEntityDescription1 } from '../../types';

interface RiskSignOffProps extends IWithErrorHandlingProps {
    lastProjectIdForChilds?: number;
    apiConnected: boolean;
    emphasiseProjectsWithCustomField: string;
    emphasisedProjectsHeaderText: string;
    otherProjectsHeaderText: string;
    onEntityDescriptionChange: (desc: IEntityDescription1) => void;
}

const RiskSignOff = (props: RiskSignOffProps) => {

    const { dataServices: { corporateRiskService, reportDueDatesService } } = useContext(DataContext);

    const [updatePeriod, setUpdatePeriod] = useState<Date>(null);
    const [showPreviousUpdate, setShowPreviousUpdate] = useState<string>('false');
    const [selectedReportPeriod, setSelectedReportPeriod] = useState<Period>(Period.Current);
    const [showOptionsAndSettings, setShowOptionsAndSettings] = useState<boolean>(false);
    const [uniqueUpdatePeriods, setUniqueUpdatePeriods] = useState<Date[]>(null);

    const { riskIdForUpdates } = useParams<{ riskIdForUpdates: string }>();
    const { requestUpdatePeriod } = useParams<{ requestUpdatePeriod: string }>();
    const history = useHistory();

    useEffect(() => {
        setUpdatePeriod(new Date(requestUpdatePeriod));
    }, [requestUpdatePeriod]);

    useEffect(() => {
        const getUniqueDates = async () => {
            if (Number(riskIdForUpdates) > 0) {
                const uniqueDates = await reportDueDatesService.getCorporateRiskUpdateUniqueDates(Number(riskIdForUpdates));
                setUniqueUpdatePeriods(uniqueDates);
            }
        }
        getUniqueDates();

        corporateRiskService.readTitlesForRiskProjectDirectorateAndGroup('Risk Updates', 'Risk Update', Number(riskIdForUpdates), null, true).then(ed => {
            props.onEntityDescriptionChange(ed);
        });

    }, [riskIdForUpdates]);

    const commandBarItems: ICommandBarItemProps[] = [
        {
            key: 'risks',
            text: 'Back to Risks',
            iconProps: { iconName: 'Back' },
            onClick: (ev, item) => {

                if (props.lastProjectIdForChilds != null) {
                    history.push(`/a2/risks-for-project/${props.lastProjectIdForChilds}`);
                }
                else {
                    //request was from risk register, so go back
                    history.push('/a3/risks');
                }
            },
        },
        // {
        //     key: 'report_updates',
        //     text: 'Report Updates',
        //     iconProps: { iconName: 'MiniExpand' },
        //     onClick: (ev, item) => {
        //         history.push(`/a2/updates-for-risk/${riskIdForUpdates}`);
        //     },
        // }
    ];

    commandBarItems.push({
        key: 'OptionsSettings',
        text: 'Options & Settings',
        iconProps: { iconName: 'MiniExpand' },
        onClick: (ev, item) => {
            console.log('options popup');
            setShowOptionsAndSettings(true);
        },
    });

    const handleChangeSelectedPeriod = (period: Period) => {
        if (period === Period.Current || period === Period.Previous) {
            setUpdatePeriod(null);
        }
        setSelectedReportPeriod(period);

    }

    const handleChangeUpdatePeriod = (dateVal: Date) => {
        if (selectedReportPeriod === Period.Specific) {
            setUpdatePeriod(dateVal);
        }
        else {
            setUpdatePeriod(null);
        }
    }

    const handleChangeShowPreviousUpdate = (value: string) => {
        setShowPreviousUpdate(value);
    }


    return (

        <div className={`${styles.cr} ${styles.updatesContainer}`}>
            <CrCommandBar items={commandBarItems} />
            <div>
                <SignOffList
                    defaultReportType={SignOffType.Risk}
                    defaultEntityId={Number(riskIdForUpdates)}
                    defaultUpdatePeriod={updatePeriod}
                    showPreviousUpdate={showPreviousUpdate === 'true'}
                    reportPeriod={selectedReportPeriod}
                    {...props}
                />
            </div>

            <SignOffPageSettings
                showForm={showOptionsAndSettings}
                showPeriodSelection={true}
                onClosed={() => setShowOptionsAndSettings(false)}
                showPreviousUpdate={showPreviousUpdate}
                onChangeShowPreviousUpdate={handleChangeShowPreviousUpdate}
                reportPeriod={selectedReportPeriod}
                onChangePeriod={handleChangeSelectedPeriod}
                uniqueUpdatePeriods={uniqueUpdatePeriods}
                updatePeriod={updatePeriod}
                onChangeUpdatePeriod={handleChangeUpdatePeriod}
            />


        </div>

    );
};

export default withErrorHandling(RiskSignOff);